import { fromUnixTime } from "date-fns";

import { invariant } from "@coinbot/forge-api/helpers";

import { midgard } from "./client";

export async function getThornodeDetails() {
  try {
    const { data: blockHeights } = await midgard.get<{
      lastThorNode: { height: number; timestamp: number };
    }>("health");

    invariant(blockHeights, "Block heights must be not empty");

    const thornodeDetails = {
      blockHeight: blockHeights?.lastThorNode?.height,
      latestTime: fromUnixTime(blockHeights?.lastThorNode?.timestamp),
    };

    return thornodeDetails;
  } catch (err) {
    console.error("getThornodeDetails error", err);
    return;
  }
}
